module.exports = __webpack_public_path__ + "static/media/Success.38d19539.svg";